import React, { useState } from 'react'
import { theme } from 'theme'
import Text from 'particles/Text'
import { Popper } from '@mui/material'
import Icon from 'components/Icon'
import styled from 'particles/themes/styled'
import { makeStyles, createStyles } from '@mui/styles'
import { useWindowSize } from 'hooks'
import SmallScreenPopper from 'components/Shared/SmallScreenPopper'
import Tooltip from 'particles/Tooltip'

interface TitleProps {
    value: string
    isFirstTitle: boolean
    isPopupInfo?: boolean
    popupInfoContent?: string
    color?: string
}
const useStyles = makeStyles(() =>
    createStyles({
        root: {
            alignItems: 'center',
            lineHeight: '24px',
            width: '100%',
            height: '100%',
            position: 'relative',
            display: 'flex',
            padding: '20px',
        },
    }),
)
const TooltipIcon = styled.div`
    display: flex;
    text-align: center;
    position: absolute;
    right: 0;
    cursor: pointer;
    &:hover {
        svg {
            path {
                fill: ${theme.colors.doveGrey};
            }
        }
    }
`

export const TitleCell = React.memo(function GridCellExpand(props: TitleProps) {
    const { value, isPopupInfo = false, isFirstTitle, popupInfoContent } = props
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const classes = useStyles()
    const [showPopper, setShowPopper] = useState(true)
    const windowSize = useWindowSize()

    const handleShowPopper = (e: any, isShow: boolean) => {
        if (windowSize && windowSize > 768) {
            setShowPopper(isShow)
            setAnchorEl(e.target)
        } else return
    }

    const popupContent = popupInfoContent ? popupInfoContent : value
    return (
        <div className={classes.root}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-between',
                    alignItems: 'center',
                    position: 'relative',
                    width: '100%',
                    overflow: 'hidden',
                    paddingRight: '20px',
                }}
            >
                <div
                    style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'break-spaces',
                        wordBreak: 'break-word',
                        overflow: 'hidden',
                    }}
                >
                    <Text scale={isFirstTitle ? 'bodyM700' : 'bodyM500'} color="primary">
                        {value}
                    </Text>
                </div>
                {isPopupInfo && (
                    <Tooltip label={popupContent}>
                        <TooltipIcon
                            onMouseEnter={(e: any) => {
                                handleShowPopper(e, true)
                            }}
                            onMouseLeave={(e: any) => {
                                handleShowPopper(e, false)
                            }}
                            onTouchStart={(e: any) => {
                                handleShowPopper(e, true)
                            }}
                            onClick={(e: any) => {
                                setShowPopper(true)
                                setAnchorEl(e.target)
                            }}
                        >
                            <Icon.InfoIcon size={'20px'} color={theme.newColors.neutral500} />
                        </TooltipIcon>
                    </Tooltip>
                )}
            </div>
            {showPopper && (
                <>
                    {windowSize && windowSize < 768 && (
                        <Popper
                            open={anchorEl !== null}
                            style={{
                                position: 'fixed',
                                zIndex: 999,
                            }}
                        >
                            <SmallScreenPopper
                                title={value}
                                description={popupInfoContent}
                                setShow={() => {
                                    setShowPopper(false)
                                }}
                            />
                        </Popper>
                    )}
                </>
            )}
        </div>
    )
})
